/* eslint-disable no-unused-vars */
import React from "react";
import { Row } from "antd";
import packedIdIcon from "../../../assests/images/packetIcon.svg";
import packetContents from "../../../assests/images/packetContents.svg";
import Plus from "../../../assests/images/plus-blue.png";
import Remove from "../../../assests/images/undo.png";

import rsIcon from "../../../assests/images/rupiIcon.svg";
import { PackedIdAndValue } from "./ManifestCard";
import { PacketFooter } from "./PacketFooter";
import { PacketContents } from "./PacketContents";

export const ManifestMiniCard = ({
  name,
  color,
  item,
  handleScanCallback,
  handleRemoveScanCallback,
}) => {
  // console.log(name?.includes("scanned"), "name");
  // console.log(checkScanEmpty, "checkScanEmpty");
  // console.log(checkEligibleEmpty, "checkEligibleEmpty");

  return (
    <div style={{ padding: "5px" }}>
      <div className="mini-reactangle-main">
        <div className={`mini-reactangle-${color}`}>
          <div className="mini-container">
            <div className="mini-container-div">
              <div>
                <img src={packedIdIcon} />
              </div>
              <div>
                <PackedIdAndValue
                  text={"AWB Number"}
                  number={item?.awbNumber}
                />
              </div>
            </div>
            <div className="mini-container-div">
              {/* <div>
                <img src={rsIcon} />
              </div> */}

              <div>
                <PackedIdAndValue text={"Value"} number={`${item?.value}`} />
              </div>
            </div>
            {!name?.includes("Scanned") ? (
              <h5
                onClick={() => handleScanCallback(item?.awbNumber)}
                style={{ cursor: "pointer", fontSize: 9 }}
              >
                {" "}
                <img src={Plus} width={18} height={18} />
              </h5>
            ) : (
              <h5
                onClick={() => handleRemoveScanCallback(item?.awbNumber)}
                style={{ cursor: "pointer", fontSize: 9 }}
              >
                {" "}
                <img src={Remove} width={16} height={16} />
              </h5>
            )}
          </div>
          <Row gutter={12} className="manifestCard-container-secondRow">
            {/* <div className="packetContent" style={{ display: "flex" }}>
              <div>
                <img src={packetContents} />
              </div>
              <div className="manifestCard-container-text">
                <div>{"Packet Contents"}</div>
                <div
                  style={{
                    maxWidth: "202px",
                    paddingLeft: "5px",
                    paddingTop: "5px",
                  }}
                >
                  <PacketContents numberOfPakcet={item?.childShipmentDetails} />
                </div>
              </div>
            </div> */}

            <div className="manifestCard-container-secondRow-footer"></div>
          </Row>
        </div>
        {/*
        <PacketFooter
          item={item?.childShipmentDetails?.length}
          childPacket={item}
        /> */}
      </div>
    </div>
  );
};
